import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideSectionLabel,
  GuideCard,
  GuideCardGrid,
  GuideBlockList,
} from "../GuideBlocks.js";

const TheEierFrameworkSection = ({ heading, accentIndex = 0, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="the-eier-framework"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      One of the simplest ways to practice structured thinking is through the{" "}
      <strong>EIER Framework</strong>. It helps you move from emotional reactions to thoughtful
      responses.
    </GuideLead>
    <GuideSectionLabel>E — Event</GuideSectionLabel>
    <p className="guide-panel__p">
      Start with the facts. Ask: <strong>What actually happened?</strong>
    </p>
    <GuideCallout>
      Example: "I expected an important email today, but I didn't receive it." Nothing more. No
      assumptions. Just the observable event.
    </GuideCallout>
    <GuideSectionLabel>I — Interpretation</GuideSectionLabel>
    <p className="guide-panel__p">Now identify the story your mind created.</p>
    <GuideBlockList
      items={[
        "They ignored me.",
        "They don't value me.",
        "I lost the opportunity.",
        "Something has gone wrong.",
      ]}
    />
    <p className="guide-panel__p">Recognize that these are interpretations—not facts.</p>
    <GuideSectionLabel>E — Evidence</GuideSectionLabel>
    <p className="guide-panel__p">Test your interpretation.</p>
    <GuideBlockList
      items={[
        "What evidence supports this thought?",
        "What evidence challenges it?",
        "What information am I missing?",
      ]}
    />
    <p className="guide-panel__p">
      Often, you'll realize your conclusion is based more on assumptions than reality.
    </p>
    <GuideSectionLabel>R — Respond</GuideSectionLabel>
    <p className="guide-panel__p">Choose your next action intentionally.</p>
    <GuideCardGrid columns={2}>
      <GuideCard iconKey="clarity" title="Possible responses">
        <GuideBlockList
          items={[
            "Wait until tomorrow.",
            "Send a polite follow-up.",
            "Make a phone call.",
            "Ask for clarification.",
            "Continue with other priorities.",
          ]}
        />
      </GuideCard>
      <GuideCard
        iconKey="awareness"
        title="The shift"
        description="Instead of reacting emotionally, you respond thoughtfully. That single shift often changes both your experience and your outcome."
      />
    </GuideCardGrid>
  </GuidePanel>
);

export default TheEierFrameworkSection;
